import type { AIAssistantConfig } from '@amzn/wwasft-components';
import { getCurrentEnvironment } from 'src/api/clients/config';

const AVAILABLE_AGENTS: AIAssistantConfig['availableAgents'] = [
  {
    id: 'fortune_agent_core',
    name: 'Fortune P&L',
    appId: 'fortune',
    description: 'Financials by business slice (e.g. Low ASP/High ASP, FC type etc.)',
  },
];

const QUICK_PROMPTS_BY_AGENT: AIAssistantConfig['quickPromptsByAgent'] = {
  fortune_agent_core: [
    { text: 'UK GMS for October 2025', fullPrompt: 'What is UK GMS for October 2025?' },
    { text: "EU5's OPPU for 2024", fullPrompt: "Show me EU5's OPPU for 2024." },
    { text: 'OI trend for NA YTD 2025', fullPrompt: 'What is the OI trend for NA YTD 2025?' },
    { text: 'Low ASP trending for JP', fullPrompt: 'How is Low ASP trending for JP in 2025?' },
    { text: 'EE profitability in US', fullPrompt: 'Show me EE profitability in the US for 2025.' },
  ],
};

const STAGE_URLS: Record<string, { socketUrl: string; serviceUrl: string }> = {
  alpha: {
    socketUrl: 'wss://us-east-1-alpha-chat-ws.atlas.taxaudits.amazon.dev',
    serviceUrl: 'https://us-east-1-alpha-chat-rest.atlas.taxaudits.amazon.dev/api/v1/',
  },
  beta: {
    socketUrl: 'wss://us-east-1-beta-chat-ws.atlas.taxaudits.amazon.dev',
    serviceUrl: 'https://us-east-1-beta-chat-rest.atlas.taxaudits.amazon.dev/api/v1/',
  },
  gamma: {
    socketUrl: 'wss://us-east-1-gamma-chat-ws.atlas.taxaudits.amazon.dev',
    serviceUrl: 'https://us-east-1-gamma-chat-rest.atlas.taxaudits.amazon.dev/api/v1/',
  },
  prod: {
    socketUrl: 'wss://us-east-1-prod-chat-ws.atlas.taxaudits.amazon.dev',
    serviceUrl: 'https://us-east-1-prod-chat-rest.atlas.taxaudits.amazon.dev/api/v1/',
  },
};

const DISCLAIMER = {
  text: 'You may need to verify responses for accuracy.',
  linkText: 'FinSpace AI Assistant T&C',
  linkUrl:
    'https://w.amazon.com/bin/view/WWCF_IPAT/FinTech/CoreEngineering/Teams/FinSpace/AIAssistantT&C',
};

const DEFAULT_STAGE = 'beta';

type AIAssistantEnvConfig = Pick<
  AIAssistantConfig,
  'socketUrl' | 'serviceUrl' | 'quickPromptsByAgent' | 'title' | 'availableAgents' | 'disclaimer'
>;

export const getAIAssistantConfig = (): AIAssistantEnvConfig => {
  const stage = getCurrentEnvironment() || DEFAULT_STAGE;
  const urls = STAGE_URLS[stage] || STAGE_URLS[DEFAULT_STAGE];
  return {
    title: 'FinSpace',
    quickPromptsByAgent: QUICK_PROMPTS_BY_AGENT,
    disclaimer: DISCLAIMER,
    ...urls,
    availableAgents: AVAILABLE_AGENTS,
  };
};
